import React, { useEffect, useMemo, useState } from "react"
import { Button, Container, Spinner, UncontrolledTooltip } from "reactstrap"
import eye from "../../assets/images/icons/eye.svg"
import { exportToExcel, formatAmount } from "helpers/common"
import TableContainer from "components/Common/TableContainer"
import Breadcrumb from "components/Common/Breadcrumb"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import { useLazyGetCommissionWpQuery } from "store/api/reports/reports"
import "flatpickr/dist/themes/material_blue.css"
import FlatPickr from "react-flatpickr"
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index"
import { Link } from "react-router-dom"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  month: "",
}

const WPCommissionReports = () => {
  const [trigger] = useLazyGetCommissionWpQuery()

  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [excelLoading, setExcelLoading] = useState(false)

  document.title = `Commision Report | Prachay`

  const getList = async () => {
    try {
      const { data, success } = await trigger(filters).unwrap()
      if (success) {
        setData(data)
      }
    } catch (error) { }
  }

  useEffect(() => {
    getList()
  }, [filters])

  const columns = useMemo(() => {
    const headers = [
      {
        header: "Name of Wealth Partner",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <DefaultAvatar
            email={row?.original?.email}
            name={row?.original?.name}
          />
        ),
      },
      {
        header: "Amount",
        accessorKey: "total_amount",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => <>₹ {formatAmount(row.original.total_amount)}</>,
      },
      {
        header: "Commission Earned",
        accessorKey: "commission",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => <>₹ {formatAmount(row.original.commission)}</>,
      },
      {
        id: "action",
        header: "Actions",
        cell: ({ row }) => {
          const viewTooltip = `editTooltip-${row?.original?.id}`

          return (
            <div className="d-flex justify-content-center align-items-center gap-3">
              <>
                <div className="action-view">
                  <Link
                    to={`/reports/commission-report/view/${row?.original?.id}`}
                    onClick={close}
                    id={viewTooltip}
                  >
                    <img src={eye} alt="" />
                    <UncontrolledTooltip placement="top" target={viewTooltip}>
                      View
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </>
            </div>
          )
        },
      },
    ]

    return headers
  }, [])

  const handleExport = async () => {
    try {
      setExcelLoading(true)
      await exportToExcel(
        "/reports/commission",
        { ...filters, exportToExcel: true },
        `Commision-Report.xlsx`
      )
    } catch (err) {
      toast.error("Export failed. Please try again.")
    } finally {
      setExcelLoading(false)
    }
  }

  const FilterComponents = () => (
    <>
      {/* <FlatPickr
        className={`form-control`}
        style={{
          maxWidth: "200px",
        }}
        placeholder="Select Month"
        options={{
          plugins: [
            new monthSelectPlugin({
              shorthand: false,
              dateFormat: "Y-m",
              altFormat: "F Y",
              theme: "light",
            }),
          ],
          dateFormat: "M, Y",
          maxDate: new Date(),
        }}
        value={filters.month}
        onChange={(date) => {
          setFilters((prev) => ({
            ...prev,
            page: 1,
            month: date,
          }))
        }}
      /> */}
      {/* <Button className="btn btn-primary" onClick={() => handleExport()}>
        {excelLoading ? (
          <Spinner color={"#FFF"} size={"sm"} />
        ) : (
          <i className="mdi mdi-file-excel"></i>
        )}
      </Button> */}
    </>
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Commision Report"} />

          <div className="quarterterly-tds-table-wrapper">
            <TableContainer
              filters={filters}
              setFilters={setFilters}
              count={data.length}
              columns={columns}
              FilterComponents={FilterComponents}
              data={data}
              buttonName={"Invite"}
              isGlobalFilter={true}
              isCustomPageSize={false}
              isPagination={false}
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers"
              tableClass="table-bordered   table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            />
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default WPCommissionReports
